fx.asset({
	
});